import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const ViewModal = ({ data, viewModal, closeView }) => {

  return (
    <Modal show={viewModal} size='lg' onHide={closeView}>
      <Modal.Header closeButton>
        <Modal.Title>{data.event_status} {data.event_name} event</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Row>
            {/* First Column */}
            <Col md={6}>
              <Form.Group controlId="event_name">
                <Form.Label>Event Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter event name"
                  name="event_name"
                  value={data.event_name}
                />
              </Form.Group>

              <Form.Group controlId="event_date">
                <Form.Label>Event Date</Form.Label>
                <Form.Control
                  type="date"
                  name="event_date"
                  value={data.event_date}
                  readOnly
                />
              </Form.Group>

              <Form.Group controlId="event_location">
                <Form.Label>Event Location</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter event location"
                  name="event_location"
                  value={data.event_location}
                  readOnly
                />
              </Form.Group>

              <Form.Group controlId="organizer_name">
                <Form.Label>Organizer Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter organizer's name"
                  name="organizer_name"
                  value={data.organizer_name}
                  readOnly
                />
              </Form.Group>

              <Form.Group controlId="capacity">
                <Form.Label>Capacity</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter capacity"
                  name="capacity"
                  value={data.capacity}
                  readOnly
                />
              </Form.Group>
            </Col>

            {/* Second Column */}
            <Col md={6}>
              <Form.Group controlId="event_description">
                <Form.Label>Event Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter event description"
                  name="event_description"
                  value={data.event_description}
                  readOnly
                />
              </Form.Group>

              <Form.Group controlId="event_time">
                <Form.Label>Event Time</Form.Label>
                <Form.Control
                  type="time"
                  name="event_time"
                  value={data.event_time}
                  readOnly
                />
              </Form.Group>

              <Form.Group controlId="event_type">
                <Form.Label>Event Type</Form.Label>
                <Form.Select
                  type="text"
                  name="event_type"
                  value={data.event_type}
                  readOnly
                >
                    <option value="">Select event type</option>
                    <option value="Workshop">Workshop</option>
                    <option value="Celebration">Celebration</option>
                    <option value="Seminar">Seminar</option>
                    <option value="Conference">Conference</option>
                    <option value="Webinar">Webinar</option>
                    <option value="Social Event">Social Event</option>
                    <option value="Fundraiser">Fundraiser</option>
                    <option value="Festival">Festival</option>
                    <option value="Exhibition">Exhibition</option>
                    <option value="Sports Event">Sports Event</option>
                    <option value="Competition">Competition</option>
                </Form.Select>
              </Form.Group>

              <Form.Group controlId="event_status">
                <Form.Label>Event Status</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter event status"
                  name="event_status"
                  value={data.event_status}
                  readOnly
                />
              </Form.Group>

              <Form.Group controlId="event_duration">
                <Form.Label>Event Duration</Form.Label>
                <Form.Select
                  name="event_duration"
                  value={data.event_duration}
                  readOnly
                >
                </Form.Select>
              </Form.Group>

              {/* Event Image Upload */}
              <Form.Group controlId="event_image">
                <Form.Label>Event Image</Form.Label>
                <Form.Control
                  type="file"
                  name="event_image"
                  accept="image/*"
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeView}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default ViewModal
